module.exports = __webpack_public_path__ + "static/media/logo-people.bc58b11f.jpg";